<template>
    <div class="row" id="financialStructure">
        <div class="col-12 text-center">
            <div class="donutChart">
                <div v-for="item in parts" :key="item.name" >
                    <div v-if="item.dag <= 180 && item.dag > 0"  class="portionBlock" :style="{ transform: 'rotate('+item.start+'deg)' }">
                        <div class="circle" :style="{ transform: 'rotate('+item.dag+'deg)', background: item.color }"></div>
                    </div>
                    <div v-if="item.dag > 180"  class="portionBlock" :style="{ transform: 'rotate('+item.start+'deg)' }">
                        <div class="circle" :style="{ transform: 'rotate(180deg)', background: item.color }"></div>
                    </div>
                    <div v-if="item.dag > 180"  class="portionBlock" :style="{ transform: 'rotate('+item.start+180+'deg)' }">
                        <div class="circle" :style="{ transform: 'rotate('+(item.dag-180)+'deg)', background: item.color }"></div>
                    </div>
                </div>
                <div class="center"></div>
            </div>
        </div>
        <div class="col-12 text-left mt-4">
            <div class="legendPart" v-for="item in parts" :key="item.name">
                <div class="color" :style="{ background: item.color }"></div>
                <div class="text">{{item.name}}: {{item.value.replace(".",",")}}%</div>
            </div>
        </div>
    </div>
    
</template>
<script>
    export default {
        props: {
            values: Array,
            gap: {
                type: String,
                default: "3"
            }
        },

        created() {
            let start = 0;
            for(let i = 0; i < this.values.length; i++) {
                let tmp = {
                    name: this.values[i].name, 
                    value: this.values[i].value, 
                    color: "#"+this.values[i].color,
                    start: start,
                    dag: (360 * (parseFloat(this.values[i].value) / 100) - parseFloat(this.gap))
                };
                this.parts.push(tmp);
                start = start + 360 * (parseFloat(this.values[i].value) / 100);
            }
        },

        data() {
            return {
                parts: []
            };
        }
    }
</script>